<template>
  <Breadcrumbs
    class=" px-0"
    :items="breadcrumbs"/>
</template>

<script>
import Breadcrumbs from 'components/common/elements/Breadcrumbs.vue'

export default {
  name: 'newPurchBread',
  props: {
    checkExit: Function
  },
  computed: {
    breadcrumbs() {
      return [
        {
          text: this.$t('Menu.Purchasing'),
          action: this.goTo
        },
        {
          text: this.$t('Catalog.NewPurchase')
        },
      ]
    }
  },
  methods: {
    submitExit() {
      this.$router.push({ name: 'purchasing' , params: {org: this.$route.params.org} })
    },
    goTo() {
      if ( this.checkExit && this.checkExit() ) {
        this.$root.$emit('showExitConfirmation', { submitExit: this.submitExit })
      } else {
        this.submitExit()
      }
    },
  },
  components: {
    Breadcrumbs
  }
}
</script>
